import React, { useState } from 'react';
import { Form, Button } from 'react-bootstrap';
import { Link, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import Auth from '../../components/layouts/auth';
import LoginAuth from '../../services/auth.service';
import { safeRedirect } from '../../utils/safeRedirect';

const Logiotp = () => {
   let navigate = useNavigate();
   const { id } = useParams();
   const [searchParams] = useSearchParams();
   // Carried through the login flow so an email link reaches its page.
   const redirectParam = searchParams.get('redirect');
   const redirectTo = safeRedirect(redirectParam);
 

   const [formData, setFormData] = useState({
      otp: '',
      userId: id
   });

   const [errors, setErrors] = useState({ otp: '' });
   const [ApiError, setApiError] = useState(false);
   const [buttonClick, setbuttonClick] = useState(false);
   const [ApiErrorMessage, setApiErrorMessage] = useState("");

   const handleChange = (e) => {
      const { id, value } = e.target;
      setFormData(prevState => ({
         ...prevState,
         [id]: value
      }));

      if (id === 'otp') {
         const isValidOtp = value.length === 6;
         setErrors(prevErrors => ({
            ...prevErrors,
            otp: isValidOtp ? '' : 'OTP must be 6 digits'
         }));
      }
   };

   const handleSignIn = async () => {
      const isValidOtp = formData.otp.length === 6;

      if (!isValidOtp) {
         setErrors(prevErrors => ({
            ...prevErrors,
            otp: 'OTP must be 6 digits'
         }));
      }

      if (isValidOtp) {
         try {
            const users = await LoginAuth.verifyLoginOtp(formData);

            // The emailed code proved the inbox. If this client has a second
            // factor set up, that is the second step, so hand off to the code
            // screen instead of letting them in here.
            if (users?.twoFactorRequired) {
               navigate('/login-2fa', {
                  state: {
                     challenge: users.challenge,
                     methods: users.methods,
                     preferred: users.preferred,
                     redirect: redirectTo,
                  },
               });
               return;
            }

            // Setup deadline passed with nothing set up: no tokens, only a challenge
            // that is good for SMS setup, which finishes the login.
            if (users?.twoFactorSetupRequired && users?.challenge) {
              navigate('/login-setup-2fa', {
                state: {
                  challenge: users.challenge,
                  phone: users.phone,
                  deadline: users.deadline,
                  smsConsent: users.smsConsent,
                  redirect: redirectTo,
                },
              });
              return;
            }

            if (users?.twoFactorSetupRequired) {
               navigate('/setup-2fa', {
                  state: {
                     forced: true,
                     redirect: redirectTo,
                     canSkip: users.canSkip,
                     deadline: users.deadline,
                  },
               });
               return;
            }

            setbuttonClick(true);
            setApiError(false);
            setApiErrorMessage(users.message);
            navigate(redirectTo, { replace: true });
         } catch (err) {
            setbuttonClick(true);
            setApiError(true);
            setApiErrorMessage(err.response.data);
         }
      }
   };

   return (
      <Auth buttonClick={buttonClick} ApiError={ApiError} ApiErrorMessage={ApiErrorMessage} pageTitle="Log in with OTP">
         <Form>
            <Form.Group className="form-group">
               <div className="text-center mt-3">
                  <Form.Label htmlFor="otp">OTP</Form.Label>
               </div>
               <Form.Control
                  type="text"
                  isInvalid={!!errors.otp}
                  id="otp"
                  aria-describedby="otp"
                  placeholder=" "
                  value={formData.otp}
                  onChange={handleChange}
               />
               <Form.Control.Feedback type="invalid">
                  {errors.otp}
               </Form.Control.Feedback>
            </Form.Group>
            <div className="d-flex justify-content-center pt-3">
               <Button className='btn btn-md px-4 rounded' onClick={handleSignIn} type="button" variant="btn btn-primary">Sign In</Button>
            </div>
            <div className='text-center pt-3'>
               <Link to="/" className="secondary-cta">Back to Login</Link>
            </div>
         </Form>
      </Auth>
   );
};

export default Logiotp;
